import { StaticImage, GatsbyImage } from 'gatsby-plugin-image';
import Layout from 'layout';
import StartUsing from 'components/ui/startUsing';
import FAQ from 'components/FAQ';
import CompareTo from 'components/CompareTo';
import { questions } from 'data/compare/fullstory/questions';
import { LIVESESSION, FULLSTORY, dataSet, icon } from 'data/compare/fullstory/table';
import Button from 'components/ui/button';
import { Header, HeadSection, Section, StyledH2, Divider } from 'components/compare/styles';
import KeyAdvantages from 'components/compare/KeyAdvantagesFullStory';
import HeadContentFullstory from 'components/compare/HeadContentFullstory';
import pricingImg from 'img/ui/pricing.svg';
import Link from 'components/ui/link';
import NewLogo from 'components/index/newLogo/index';
import Opinion from 'components/compare/Opinion';
import CustomersRate from 'components/compare/CustomersRate';
import Banner from 'components/compare/Banner';
import { graphql, useStaticQuery } from 'gatsby';

const FullStoryCompare = () => {
  const { hero } = useStaticQuery(graphql`
    {
      hero: file(relativePath: { eq: "fullstory-alternative/hero.png" }) {
        childImageSharp {
          gatsbyImageData(placeholder: BLURRED)
        }
      }
    }
  `);
  return (
    <Layout
      metaDescription="Try LiveSession, a better FullStory alternative. Choose flexible pricing, custom properties, engagement scores and get even more from your session replays."
      metaTitle="FullStory Alternative | Better Session Recordings"
      canonical="/compare/fullstory-alternative/"
    >
      <Header>
        <div className="container">
          <div className="head-content-box">
            <h1 className="line">
              <span>LiveSession</span> is a better choice than FullStory
            </h1>
            <p>Flexible plans, custom properties and much more.</p>
            <Button secondary signUp sourceID="hero">
              Sign up free
            </Button>
          </div>
          <GatsbyImage
            image={hero.childImageSharp.gatsbyImageData}
            alt="livesession vs fullstory"
            loading="eager"
            title="Compare LiveSession with FullStory"
            objectFit="contain"
            objectPosition="center"
          />
        </div>
      </Header>
      <div className="container">
        <HeadSection>
          <HeadContentFullstory />
        </HeadSection>
        <StyledH2 className="line">
          Where <span>LiveSession</span> takes the lead over FullStory
        </StyledH2>
        <Section className="pb-240-168-120-90 pt-120-90">
          <StaticImage
            src="../../img/fullstory-alternative/pricing.png"
            alt="flexible and transparent pricing"
          />
          <div className="content-box">
            <img src={pricingImg} alt="pricing-icon" title="Pricing" />
            <h3>Flexible and transparent pricing</h3>
            <p>
              You can get LiveSession for just <strong>$49 per month</strong>. The plan is flexible
              and you can always change your mind.
              <br />
              <br />
              What’s more, you can choose <strong>a monthly subscription</strong> instead of the
              annual one. You don’t have to commit for a whole year, and you don’t have to pay for
              12 months at once. The subscription can be tailored to your needs.
            </p>
            <div className="buttons">
              <Button secondary signUp sourceID="pricing">
                Sign up free
              </Button>
              <Link withArrow href="/pricing/">
                Read more now
              </Link>
            </div>
          </div>
        </Section>
        <CompareTo
          LSbase={LIVESESSION}
          compareBase={FULLSTORY}
          dataSetBase={dataSet}
          compareTo="FullStory"
          icon={icon}
          title="LiveSession vs. FullStory"
          desc="Here’s why LiveSession might be a better alternative."
        />
        <Banner
          title={
            <h2 className="line">
              By choosing <span>LiveSession</span> instead of FullStory you can save over
            </h2>
          }
          desc="How did we calculate it? 100k sessions in FullStory cost $10200. With LiveSession it’s
          only $5089."
        />
        <KeyAdvantages />
        <Opinion
          opinion="LiveSession really listens to customer feedback and answers our needs. The app works smoothly with complex SPA applications and it truly helps us improve user experience."
          companyID="livereacting"
        />
        <CustomersRate className="hero-page" />
        <FAQ questions={questions} twoColumns />
        <Divider />
      </div>
      <div className="pbclear">
        <NewLogo />
      </div>
      <StartUsing />
    </Layout>
  );
};

export default FullStoryCompare;
